import styled from 'styled-components';

import { Text } from '@/components/UI/Typography/Text';

export const ConfirmShell = styled.div`
  width: min(100%, 1180px);
`;

export const ConfirmPanel = styled.section`
  width: min(100%, 1180px);
  padding: 34px 52px 40px;
  border-radius: ${(p) => p.theme.radii.lg};
  background: ${(p) => p.theme.colors.light};

  @media (max-width: 768px) {
    padding: 28px 20px;
  }
`;

export const SectionTitle = styled.h3`
  margin: 0 0 16px;
  color: ${(p) => p.theme.colors.primary500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  font-weight: 700;
`;

export const BodyText = styled(Text)`
  margin: 0 0 22px;
  color: ${(p) => p.theme.colors.gray500};
  line-height: 1.35;
`;

export const MeetingTitleRow = styled.div`
  display: grid;
  grid-template-columns: 110px minmax(0, 1fr);
  gap: 18px;
  margin-bottom: 18px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 4px;
  }
`;

export const FieldLabel = styled(Text)`
  margin: 0;
  color: ${(p) => p.theme.colors.gray300};
`;

export const FieldValue = styled(Text)`
  margin: 0;
  color: ${(p) => p.theme.colors.gray500};
  overflow-wrap: anywhere;
`;

export const OptionList = styled.div`
  display: grid;
  gap: 14px;
  margin-bottom: 34px;
`;

export const OptionLabel = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.base};
  line-height: 1.35;
  cursor: pointer;

  input {
    width: 18px;
    height: 18px;
    margin-top: 2px;
    flex: 0 0 auto;
  }
`;

export const UnavailableReasonLabel = styled.label`
  display: grid;
  gap: 6px;
  margin: 0 0 36px;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.base};

  @media (max-width: 640px) {
    margin-left: 0;
  }
`;

export const UnavailableReasonInput = styled.textarea`
  width: 100%;
  min-height: 46px;
  padding: 8px 0;
  border: 0;
  border-bottom: 1px solid ${(p) => p.theme.colors.gray200};
  color: ${(p) => p.theme.colors.gray500};
  font-family: inherit;
  font-size: ${(p) => p.theme.fontSizes.base};
  resize: vertical;

  &:focus {
    outline: none;
    border-bottom-color: ${(p) => p.theme.colors.primary500};
  }
`;

export const ActionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 28px;
`;

export const ReturnButton = styled.button`
  border: 0;
  background: transparent;
  color: ${(p) => p.theme.colors.primary500};
  font-size: ${(p) => p.theme.fontSizes.md};
  text-decoration: underline;
  cursor: pointer;
`;

export const ModalSurface = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: min(500px, calc(100vw - 32px));
  padding: 46px 72px 30px;
  border-radius: ${(p) => p.theme.radii.lg};
  background: ${(p) => p.theme.colors.light};
  transform: translate(-50%, -50%);
  text-align: center;

  @media (max-width: 640px) {
    padding: 34px 24px 26px;
  }
`;

export const ModalText = styled(Text)`
  margin: 0 0 22px;
  color: ${(p) => p.theme.colors.gray500};
  line-height: 1.35;
`;

export const ModalTime = styled(Text)`
  margin: 0 0 32px;
  color: ${(p) => p.theme.colors.primary500};
  font-weight: 700;
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;

  @media (max-width: 520px) {
    flex-direction: column;
  }
`;
